import { formatDate } from "@/v2/utils";

interface DefaultCellProps {
    value: string | number | null | undefined;
    minWidth?: number | null;
}

export default function DateCell({ value, minWidth }: DefaultCellProps) {
    const date = value as string;

    if (date) {
        try {
            return (
                <p
                    className={`${!navigator.userAgent.includes("Safari") ? "min-w-max" : "whitespace-nowrap"} min-w-[100px] text-center`}
                >
                    {formatDate(date, "DD-MMM-YYYY")}
                </p>
            );
        } catch (error) {
            // If date parsing fails, show a dash or the original value
            return (
                <div
                    className={`${!navigator.userAgent.includes("Safari") ? "min-w-max" : "whitespace-nowrap"} min-w-[100px] text-center`}
                    style={{
                        minWidth: minWidth || 0,
                    }}
                >
                    -
                </div>
            );
        }
    } else {
        return (
            <div
                className={`${!navigator.userAgent.includes("Safari") ? "min-w-max" : "whitespace-nowrap"} min-w-[100px] text-center`}
                style={{
                    minWidth: minWidth || 0,
                }}
            >
                -
            </div>
        );
    }
}
